module.exports = __webpack_public_path__ + "img/phone.6c150fb8.svg";